import { atom } from "recoil";
export const fileUrlState = atom({
    key: "fileUrlState", // unique ID (with respect to other atoms/selectors)
    default: "", // default value (aka initial value)
});
